<div class="error-container">
	<div class="error-section">
		<h2>{{ errorMsg.header }}</h2>
		<h4>{{ errorMsg.body }}</h4>
	</div>
</div>
